import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

import UnitCodePopup from '../components/common/UnitCodePopup';
import HomePanel from '../components/home/HomePanel';
import HomeHero from '../components/home/HomeHero';
import WhyChooseBanner from '../components/home/WhyChooseBanner';
import TeachersSection from '../components/home/TeachersSection';
import HomeCtaBanner from '../components/home/HomeCtaBanner';
import HomeFaq from '../components/home/HomeFaq';
import Students2027RegisterPopup from '../components/home/Students2027RegisterPopup';

const Home: React.FC = () => {
  const { isAuthenticated, currentUser, hasEnrolledCourses, checkEnrolledCourses } = useAuth();
  const [isUnitCodePopupOpen, setIsUnitCodePopupOpen] = useState(false);
  const isCheckingEnrollment = isAuthenticated && hasEnrolledCourses === null;

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (isAuthenticated && currentUser?.id && hasEnrolledCourses === null) {
      checkEnrolledCourses();
    }
  }, [isAuthenticated, currentUser?.id, hasEnrolledCourses, checkEnrolledCourses]);

  if (isCheckingEnrollment) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F5F1E8]">
        <div className="h-12 w-12 animate-spin rounded-full border-t-2 border-b-2 border-[#001848]" />
      </div>
    );
  }

  return (
    <div className="relative min-h-screen overflow-x-hidden bg-[#F5F1E8]" dir="rtl">
      <HomeHero />

      <div className="relative z-[1] pb-6 sm:pb-8">
        <div
          className="pointer-events-none absolute inset-0 z-0"
          aria-hidden
          style={{
            backgroundImage:
              'linear-gradient(rgba(0,24,72,0.045) 1px, transparent 1px), linear-gradient(90deg, rgba(0,24,72,0.045) 1px, transparent 1px)',
            backgroundSize: '28px 28px',
          }}
        />
        <div
          className="pointer-events-none absolute inset-0 z-0 opacity-60"
          aria-hidden
          style={{
            backgroundImage:
              'radial-gradient(ellipse 55% 40% at 85% 8%, rgba(192,144,72,0.1), transparent), radial-gradient(ellipse 45% 35% at 8% 55%, rgba(0,24,72,0.035), transparent)',
          }}
        />

        <HomePanel first>
          <WhyChooseBanner embedded />
        </HomePanel>

        <section className="relative overflow-x-hidden px-2 py-10 sm:px-3 sm:py-12 lg:px-5 lg:py-14">
          <div className="relative mx-auto max-w-[92rem] rounded-[1.5rem] border border-[#E5DCCF]/90 bg-[#FAF7F0]/70 px-4 py-8 sm:rounded-[2rem] sm:px-6 sm:py-10 lg:rounded-[2.25rem] lg:px-8 lg:py-12">
            <TeachersSection embedded />
          </div>
        </section>

        <HomeCtaBanner />

        <HomePanel>
          <HomeFaq embedded />
        </HomePanel>

        <UnitCodePopup
          isOpen={isUnitCodePopupOpen}
          onClose={() => setIsUnitCodePopupOpen(false)}
        />

        {mounted && !isAuthenticated && <Students2027RegisterPopup enabled />}
      </div>
    </div>
  );
};

export default React.memo(Home);
